import React, { forwardRef, useImperativeHandle, useCallback, useEffect, useState, useMemo } from 'react'
import qs from 'qs'
import { Spin } from 'antd'
import { request } from 'meinian-package/src/utils'
import Icon from 'meinian-package/src/component/icon'
import Empty from 'meinian-package/src/baseComponent/empty'
import { TOP_10_TYPE_ENUM } from 'meinian-package/src/component/enum'
import { PLATFORM_VALUE, PLATFORM_CONFIG_ENUM } from 'meinian-package/src/component/platformConfig'
import { useRequest } from 'ahooks'
import { SwitchPageTabContent } from '../switchTab'
import getHrefQueryString from '../styleFilter/getAnalysisHrefQueryString'
import SourcePlatformSelect from './sourcePlatformSelect'
import { getUrlLocation } from '../../../common/url'
import styles from './index.module.less'

export default forwardRef(({ baseParams, parentItem, wrapParams = {}, platformOptions }, ref) => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const [data, setData] = useState([])
  const [platformId, setPlatformId] = useState(parentItem.value)
  const innerParams = { ...baseParams, ...wrapParams }
  const [tabType, setTabType] = useState(null)

  useEffect(() => {
    if (innerParams.platformId) {
      run(innerParams)
    }
  }, [baseParams.platformId, parentItem])

  useEffect(() => {
    onPlatformId(parentItem.value)
  }, [parentItem])

  const onPlatformId = (val) => {
    if (PLATFORM_CONFIG_ENUM.get(+val)?.top10TypeOptions) {
      setTabType(PLATFORM_CONFIG_ENUM.get(+val)?.top10TypeOptions[0].value)
    } else {
      setTabType(null)
    }
    setPlatformId(val)
  }

  const { loading, run } = useRequest((_params) => request.get('/zhikuan/mn/collect-statistic/v2/source-top', {
    params: _params,
  }), {
    manual: true,
    onSuccess: (result) => {
      result.forEach(itemWrap => {
        itemWrap.topList?.forEach((item, index) => {
          item.rank = index + 1
          item.type = itemWrap.type
        })
      })
      setData(result)
    }
  })

  useImperativeHandle(ref, () => ({
    onUpdate: (_params) => run(_params)
  }))

  const getLogo = useCallback((item) => {
    if (item.logoUrl) {
      return <img src={item.logoUrl} className="head-portrait" />
    }
    const lastName = item.name.slice(0, 1)
    return <span className="head-portrait">{lastName}</span>
  }, [])

  const onLink = (item) => {
    // const sourceEnum = {
    //   1: '淘宝店铺',
    //   2: 'ins博主',
    //   3: '小红书博主',
    //   4: '品牌',
    //   5: '抖音商品',
    //   6: '抖音作品',
    //   7: '海外探款',
    //   9: '知小红'
    // }
    let url = ''
    switch (item.type) {
      case 1: url = `/shopDetail/baseInfo?shopId=${item.id}`; break
      case 2:
        if (+parentItem.value === PLATFORM_VALUE.CROSSBORDER_INS || +parentItem.value === PLATFORM_VALUE.CROSSBORDER_INS_GOODS) {
          url = `/cross-border/streamer-detail/info?bloggerId=${item.id} `
          break
        } else {
          url = `/df/detail/blogger?id=${item.id}&sourceType=1&gender=${wrapParams.gender ? wrapParams.gender : ''} `
          break
        }
      case 3: url = `/df/detail/blogger?id=${item.id}&sourceType=5&gender=${wrapParams.gender ? wrapParams.gender : ''} `; break
      case 4:
        if (+parentItem.value === PLATFORM_VALUE.ITEM) {
          break
        } else if (+parentItem.value === PLATFORM_VALUE.DY) {
          url = `/douyin/brandDetail/overview?brand=${encodeURIComponent(item.id)}`
          break
        } else if (+parentItem.value === PLATFORM_VALUE.DW_GOODS) {
          url = `/df/dw/detail/brand?brandId=${encodeURIComponent(item.id)}`
          break
        } else {
          url = `/df/detail/brand?brand=${encodeURIComponent(item.id)}`
          break
        }
      case 5: url = `/douyin/hostDetail/overview?hostId=${item.id}`; break
      case 6: url = `/douyin/shopDetail?shopId=${item.id}`; break
      case 7:
        // eslint-disable-next-line no-case-declarations
        const _platformId = String(item.platformInfo.platformType).substring(1)
        if (_platformId === '04') {
          url = '/cross-border/amazon/goods-repository'
        } else if (_platformId === '09') {
          url = ''
        } else if (_platformId === '803') {
          url = '/cross-border/temu'
        } else if (_platformId === '822') {
          url = '/cross-border/ozon'
        } else {
          url = `/cross-border/site-detail/goods?platformType=${_platformId}`
        }
        break
      case 9:
        url = `/xhs/up/overview?id=${item.id}`
        break
      case 10:
        url = `/cross-border/pinterest-streamer-detail/pins?pinterestUserId=${item.id}`
        break
      case 11:
        url = `/df/detail/profiles/picture?id=${item.id}&sourceType=7&gender=${wrapParams.gender ? wrapParams.gender : ''}`
        break
      default: break
    }
    url && window.open(url)
  }

  const dataList = useMemo(() => {
    return tabType ? data.find(item => item.type === tabType) : data?.[0]
  }, [tabType, data])

  const onHref = (item) => {
    const queryString = getHrefQueryString({ ...baseParams, platformId })
    if (location.pathname.startsWith('/meinian/home/coll/detail') && query.inspirationId) {
      window.open(`${location.pathname + location.search}&publishKeyword=${item.name}&${queryString}`)
    } else {
      window.open(`/meinian/home/all?publishKeyword=${item.name}&${queryString}`)
    }
  }

  const hasHref = (item) => {
    if (item.type === TOP_10_TYPE_ENUM.CAI_JI_ZHAN_DIAN) {
      return false
    }
    if (+platformId === PLATFORM_VALUE.ITEM && item.type === TOP_10_TYPE_ENUM.PIN_PAI) {
      return false
    }
    if (+platformId === PLATFORM_VALUE.DY && item.type === TOP_10_TYPE_ENUM.PIN_PAI) {
      return false
    }
    return true
  }

  return (<div className={styles['meinian-shop-top']}>
    <Spin spinning={loading}>
      <div style={{ padding: '0 24px' }}>
        <div className="meinian-shop-top-header">
          <span className="df-center">
            <span className="meinian-shop-top-header-point" style={{ backgroundColor: parentItem.color }} />
            <span className="meinian-shop-top-header-text">{dataList?.title ? dataList?.title : 'Top 10' }</span>
            {
              PLATFORM_CONFIG_ENUM.get(+platformId)?.top10TypeOptions?.length ? <SwitchPageTabContent
                className="meinian-shop-top-tab"
                value={tabType}
                options={PLATFORM_CONFIG_ENUM.get(+platformId)?.top10TypeOptions}
                onChange={(val) => {
                  setTabType(val)
                }}
              /> : null
            }
          </span>
          <div>
            {
              !!platformOptions.length && <SourcePlatformSelect
                options={platformOptions}
                value={platformId}
                trigger="click"
                overlayStyle={{ width: 'max-content' }}
                placement="bottomRight"
                onChange={(val) => {
                  onPlatformId(val)
                  run({ ...innerParams, platformId: val })
                }}
              />
            }
          </div>
        </div>
        <div style={{ height: '200px', overflow: 'auto', marginTop: '24px' }}>
          {
            dataList?.topList?.length ? <table className="meinian-shop-top-table">
              <tbody>
                {
                  dataList?.topList?.map((item, index) => <tr
                    className="meinian-shop-top-table-tr"
                    key={index}
                    onClick={() => {
                      if (+platformId === PLATFORM_VALUE.CROSSBORDER_SHOW) {
                        return
                      }
                      if (+platformId === PLATFORM_VALUE.COLLECT_PLUG && item.forwardUrl) {
                        const curLocation = getUrlLocation(item.forwardUrl)
                        curLocation && window.open(`${curLocation.origin}`)
                      } else {
                        onLink(item)
                      }
                    }}
                  >
                    <td className="meinian-shop-top-table-col1">{item.rank}</td>
                    <td className="meinian-shop-top-table-col2">
                      {getLogo(item)}
                      {item.name}
                    </td>
                    <td className="meinian-shop-top-table-col3">
                      <span className="col3-number">{item.imageNum}</span>
                      <span className="col3-text">采集</span>
                    </td>
                    {
                      hasHref(item) && <td className="meinian-shop-top-table-col3">
                        <span onClick={(e) => {
                          e.stopPropagation()
                          onHref(item)
                        }}
                        >查看款式<Icon type="m-Vxing_you" /></span>
                      </td>
                    }
                  </tr>)
                }
              </tbody>
            </table> : <Empty type="analysis" noPadding style={{ height: '180px' }} />
          }
        </div>
      </div>
    </Spin>
  </div>)
})
